import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

interface WarningAlertProps {
  title: string;
  isOpen: boolean;
  errors: string[];
  onCloseAlert: () => void;
}

export function WarningAlert({ title, isOpen, errors, onCloseAlert }: WarningAlertProps) {
  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="!bg-white text-black">
        <AlertDialogHeader className="items-center justify-center">
          <div className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <AlertTriangle className="h-5 w-5 text-red-500" />
              <AlertDialogTitle>{title}</AlertDialogTitle>
            </div>
            <AlertDialogDescription>
              <ul className="list-inside list-disc text-black">
                {errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </AlertDialogDescription>
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction className="!bg-[#000] text-white" onClick={onCloseAlert}>
            Close
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
